// extracted by mini-css-extract-plugin
export default {"finance":"MyTransactions_finance__4KThs"};